import { render, staticRenderFns } from "./JapaneseShow.vue?vue&type=template&id=e59ad108&scoped=true"
import script from "./JapaneseShow.vue?vue&type=script&lang=js"
export * from "./JapaneseShow.vue?vue&type=script&lang=js"
import style0 from "./JapaneseShow.vue?vue&type=style&index=0&id=e59ad108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59ad108",
  null
  
)

export default component.exports